import { render, staticRenderFns } from "./wholesaleProgramme.vue?vue&type=template&id=76bfaf32&scoped=true"
import script from "./wholesaleProgramme.vue?vue&type=script&lang=js"
export * from "./wholesaleProgramme.vue?vue&type=script&lang=js"
import style0 from "./wholesaleProgramme.vue?vue&type=style&index=0&id=76bfaf32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bfaf32",
  null
  
)

export default component.exports